define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseCategoriesWidget = require('web-agent-widgets/BaseCategoriesWidget');
    var widgetConfig = require('web-agent-widgets/widgetConfig');

    var OperatorAlertsWidget = BaseCategoriesWidget.extend({
        ControllerName: "OperatorAlertsWidget",
        applicationType: 'OperatorAlertsWidget',

        LPInfoLineType: {
            INFO: "type1"
        },

        initialize: function () {
            this.hidden = true;
        },

        events: function () {
            this.bindModel({modelPath : this.getRootModelPath() + ".data", callback : this.alertsChanged});
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            this.bindModel({modelPath : participantPath + ".participantInfo" + ".appServerVisitorId", callback : this.handleServerVisitorIdChanged});
            this.bindModel({modelPath : participantPath + ".participantInfo.sessionId", callback : this.handleSessionIdChanged});
        },

        render: function () {
        }
    });

    OperatorAlertsWidget.prototype.getConfiguration = function () {
        var configuration = {
            rowTemplateFile: "LP_visit_info_row.html",
            rootModelPath: this.getRootModelPath(),
            dataRenderer: this.dataRenderer,
            sectionOwnerIdTag: "time",
            textPrefix: "operatorAlerts",
            updateDataCallback: this.refreshClicked,
            context: this
        };
        return configuration;
    };

    OperatorAlertsWidget.prototype.getRootModelPath = function () {
        return "participants.info." + this.visitorId;
    };

    OperatorAlertsWidget.prototype.alertsChanged = function (data) {
        if (data && data.newValue && data.newValue.operatorAlerts) {
            var widgetConfiguration = widgetConfig.getInstance().getWidgetConfig("operatorAlerts");
            var dataToRender = widgetConfig.getInstance().generateWidgetData(widgetConfiguration, data.newValue);
            this.updateModelData(dataToRender.sections);
            this.hidden = !dataToRender.sections.length;
            this.showWidget();
        }
    };

    OperatorAlertsWidget.prototype.refreshClicked = function () {
        lpTag.WebAgent.visitorInfoController.startPollingVisitorInfo(this.visitorId, this.appSrvId, this.sessionId);
    };

    OperatorAlertsWidget.prototype.handleServerVisitorIdChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        this.appSrvId = data.newValue;
    };

    OperatorAlertsWidget.prototype.handleSessionIdChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        this.sessionId = data.newValue;
    };

    OperatorAlertsWidget.prototype.dataStateChanged = function (data) {
        if (!data || !data.newValue) {
            return;
        }

        if (data.newValue === 'partial') {
            this.bindAgentSessionVisit();
        } else {
            BaseCategoriesWidget.prototype.setState.call(this, data.newValue);
        }
    };

    OperatorAlertsWidget.prototype.handleStateFromAppServer = function (data) {
        if (!data || !data.newValue) {
            return;
        }

        if (data.newValue.success) {
            BaseCategoriesWidget.prototype.setState.call(this, 'success');
        } else {
            BaseCategoriesWidget.prototype.setState.call(this, 'error');
        }

        this.unbindModel({modelPath : "participants.infoServices.agentSessionVisit."+ this.visitorId+ ".state", callback : this.handleStateFromAppServer});

    };

    OperatorAlertsWidget.prototype.bindAgentSessionVisit = function () {
        this.bindModel({modelPath : "participants.infoServices.agentSessionVisit."+ this.visitorId+ ".state", callback : this.handleStateFromAppServer});
    };

    OperatorAlertsWidget.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return data.length;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data[sectionIndex].rows.length;
        },
        dataForSection: function (data, sectionIndex) {
            return {title: data[sectionIndex].display.title, selected: "selected"};
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[sectionIndex].rows[rowIndex].display;
            var value = getValue(rowData);
            return {
                rowData: rowData,
                type: this.LPInfoLineType.INFO,
                labelTitle: rowData.title,
                labelTitleTooltip: rowData.title,
                labelDetails: '',
                unescapedValue: '',
                labelDetailsTooltip: '',
                unescapedTooltip: '',
                value: value,
                valueTooltip: value,
                link: '',
                arrayValue: '',
                icon: ''
            };

            function getValue(rowData) {
                var value;
                if (rowData.time) {
                    value = lpUtils.formatDateAsShortTime(lpUtils.createDate(rowData.time, lpUtils.FORMAT_TYPES.ENGAGEMENT_WINDOW));
                } else {
                    value = rowData.value;
                }
                return value;
            }
        }
    };

    return OperatorAlertsWidget;

});
